<template>
  <div>
    <v-container fluid style="padding: 0 25px;">
      <!-- <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64" type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t('DatabaseIntegration_title') }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader> -->
      <v-card class="card2" style="margin-top: 10px;">
        <v-card-text style="margin-top: -15px;">
          <v-row align="center">
            <v-col cols="12" md="6">
              <h1 style="font-weight: 600; font-size: 28px;" class="mr-4">Table List</h1>
            </v-col>
            <v-col cols="12" md="6" class="d-flex flex-wrap justify-end gap-2">
                  <div class="custom-search-input-wrapper">
                    <div class="custom-search-input-container">
                      <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                      <input id="field-search-rowtable-dataIntegration" type="text" placeholder="Table Name"
                        class="custom-search-input" v-model="searchDataIntegrationName" @keydown.enter="Search" />
                      <v-icon class="clear-icon" :style="searchDataIntegrationName ? '' : 'color: transparent !important;'"
                        @click="searchDataIntegrationName = ''">
                        mdi-close-circle
                      </v-icon>
                    </div>
                  </div>
              <v-dialog v-model="AddDataIntegration" max-width="800" persistent class="modern-dialog">
                <template v-slot:activator="{ props: activatorProps }">
                  <v-btn
                    id="button-add-dataIntergration"
                    color="primary"
                    class="control-btn create-btn customadd"
                    variant="flat"
                    size="small"
                    @click="Add()"
                    rounded="lg"
                    v-bind="activatorProps"
                  >
                    <v-img :src="images.plusIcon" width="20" height="20" class="mr-2" />
                    {{ $t('add') }}
                  </v-btn>
                </template>

                <v-card class="dialog-card" elevation="0">
                  <!-- Enhanced Header -->
                  <div class="pa-5 headersection">
                    <div class="header-main">
                      <div class="header-text-content">
                        <h2 style="font-weight: 600;">Add Knowledge Table</h2>
                        <p style="color:#646464">This table will be used as a data source for your model.</p>
                      </div>
                    </div>
                    <div class="header-actions">
                      <v-btn icon variant="text" @click="closeDialogAddDataIntegration" class="close-button">
                        <v-icon size="20">mdi-close</v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <v-divider class="header-divider"></v-divider>

                  <v-card-text class="modern-content">
                    <!-- System Type Selection -->
                    <div class="section-container">
                      <v-card class="cardButton" variant="outlined" border="sm">
                        <v-btn-toggle
                          v-model="requestDataIntegration.Type"
                          rounded="0"
                          group
                          class="custom-toggle"
                        >
                        <v-btn value="I">
                          File Import
                          <v-tooltip text="Upload and Excel file to create a table" location="top">
                            <template v-slot:activator="{ props }">
                              <v-img
                                v-bind="props"
                                v-if="requestDataIntegration.Type == 'E'"
                                :src="images.info"
                                width="15"
                                height="15"
                                class="ml-1 cursor-pointer"
                              />
                              <v-img
                                v-bind="props"
                                v-else-if="requestDataIntegration.Type == 'I'"
                                :src="images.infoactive"
                                width="15"
                                height="15"
                                class="ml-1 cursor-pointer"
                              />
                            </template>
                          </v-tooltip>
                        </v-btn>
                          <v-btn value="E">Database Connection 
                            <v-tooltip text="Connect to your existing database to use a table" location="top">
                            <template v-slot:activator="{ props }">
                              <v-img
                                v-bind="props"
                                v-if="requestDataIntegration.Type == 'I'"
                                :src="images.info"
                                width="15"
                                height="15"
                                class="ml-1 cursor-pointer"
                              />
                              <v-img
                                v-bind="props"
                                v-else-if="requestDataIntegration.Type == 'E'"
                                :src="images.infoactive"
                                width="15"
                                height="15"
                                class="ml-1 cursor-pointer"
                              />
                            </template>
                          </v-tooltip>
                          </v-btn>
                        </v-btn-toggle>
                      </v-card>
                    </div>
                    <!-- Internal System Configuration -->
                    <div v-show="requestDataIntegration.Type == 'I'" class="config-section">
                      <div class="section-container">
                        <div class="form-grid">
                          <div class="form-group form-group-large">
                            <v-text-field
                              id="add-tablename-internal-dataIntegration"
                              v-model="requestDataIntegration.DataIntegrationName"
                              :rules="[rules.required]"
                              variant="outlined"
                              density="comfortable"
                              class="modern-input"
                              color="#3859D0"
                            >
                              <template v-slot:label>
                                Table Name<span style="color: red;"> *</span>
                              </template>
                              <v-tooltip width="300" text="Table Name Information" location="top"></v-tooltip>
                            </v-text-field>
                          </div>
                        </div>
                        <div class="form-group upload-section">
                          
                            <div class="upload-container">
                              <v-tooltip text="Select an excel file to upload" location="top">
                                  <template v-slot:activator="{ props }">
                                    <div v-bind="props" class="upload-area">
                                      <!-- ปุ่มอัปโหลดหลัก -->
                                      <v-btn id="proxy-upload-button" variant="elevated" size="large" prepend-icon="mdi-cloud-upload" @click="triggerFileUpload" class="upload-main-btn">
                                        <span class="upload-text">Upload File</span>
                                      </v-btn>

                                      <!-- ข้อมูลเพิ่มเติม -->
                                      <div class="upload-info">
                                        <div class="upload-description">
                                          <v-img :src="images.uploadexcelImg" width="20" height="20" />
                                          <span class="upload-hint">Select an Excel file (.xlsx) to upload.</span>
                                        </div>
                                      </div>

                                      <!-- แสดงชื่อไฟล์ที่เลือก (ถ้ามี) -->
                                      <div v-if="uploadedFiles.length > 0" class="uploaded-file-info">
                                        <v-chip variant="elevated" size="small" class="file-chip">
                                          <v-img :src="images.excelImg" width="16" height="16" class="mr-2" />
                                          {{ uploadedFiles[0].name }}
                                        </v-chip>
                                      </div>
                                    </div>
                                  </template>
                                </v-tooltip>

                              <!-- DragDropFile ที่ซ่อนไว้ -->
                              <DragDropFile
                                ref="dragDropRef"
                                :dialog="true"
                                :DragDrop="false"
                                :ShowListFile="false"
                                :accept="accept"
                                @filesUploaded="processUpload($event)"
                                :allowType="[]"
                                class="modern-upload hidden-upload"
                                id="add-UploadFile-Internal-DataIntegration"
                              />
                            </div>
                            
                          </div>
                        <!-- Columns Configuration -->
                        <div v-if="requestDataIntegration.Columns.length > 0 && requestDataIntegration.entity != null" class="columns-section">
                          <div class="columns-header">
                            <h3 class="columns-title">Column Configuration</h3>
                            <!-- <v-chip size="small" color="primary" variant="tonal">
                              {{ requestDataIntegration.Columns.length }}
                              columns
                            </v-chip> -->
                          </div>

                          <div class="columns-list">
                            <v-card v-for="(item, index) in requestDataIntegration.Columns" :key="index" class="column-card" variant="outlined">
                              <v-card-text class="column-content">
                                <div class="column-fields">
                                  <v-text-field
                                    :id="`add-columnName-Internal-dataIntegration-${index}`"
                                    :label="$t('_columnDataIntegration')"
                                    v-model="item.name"
                                    variant="outlined"
                                    density="comfortable"
                                    class="column-input modern-input"
                                    :error="errorMessages.columns[index]?.error"
                                    :error-messages="errorMessages.columns[index]?.message"
                                  >
                                    <!-- <template v-slot:append-inner>
                                      <v-tooltip :text="$t('_columnDataIntegration')" location="top">
                                        <template v-slot:activator="{ props }">
                                          <v-icon v-bind="props" size="14" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                                        </template>
                                      </v-tooltip>
                                    </template> -->
                                  </v-text-field>

                                  <v-select
                                    :id="`add-dataType-Internal-dataIntegration-${index}`"
                                    :label="$t('_typeDataIntegration')"
                                    :items="DDDataType"
                                    item-title="name"
                                    item-value="id"
                                    v-model="item.typeId"
                                    @update:model-value="setDefault(item)"
                                    variant="outlined"
                                    density="comfortable"
                                    class="column-input modern-input"
                                  >
                                    <!-- <template v-slot:append-inner>
                                      <v-tooltip :text="$t('_typeDataIntegration')" location="top">
                                        <template v-slot:activator="{ props }">
                                          <v-icon v-bind="props" size="14" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                                        </template>
                                      </v-tooltip>
                                    </template> -->
                                  </v-select>
                                </div>

                                <div class="column-fields">
                                  <v-select
                                    :items="fuzzyOptions"
                                    item-title="text"
                                    item-value="value"
                                    variant="outlined"
                                    class="fuzzy-select modern-input"
                                    density="compact"
                                    hide-details
                                    @update:model-value="setFuzzyValue(item, $event)"
                                    :disabled="item.typeId != 'nvarchar' && item.typeId != 'varchar' && item.typeId != 'varchar2' && item.typeId != 'text' 
                                    && item.typeId != 'char' && item.typeId != 'nchar' && item.typeId != 'VARCHAR2' && item.typeId != 'TEXT'
                                    && item.typeId != 'CHAR' && item.typeId != 'NCHAR' && item.typeId != 'NVARCHAR2'"
                                  >
                                    <template v-slot:selection="{ item: selectedItem }">
                                      <div class="selection-content">
                                        <!-- <v-icon :color="getFuzzyColor(selectedItem.raw)" size="16" class="mr-2">
                                          {{ getFuzzyIcon(selectedItem.raw) }}
                                        </v-icon> -->
                                        <span class="selection-text">{{ selectedItem.raw.text }}</span>
                                      </div>
                                    </template>

                                    <template v-slot:item="{ props, item: dropdownItem }">
                                      <v-list-item v-bind="props" class="fuzzy-list-item">
                                        <!-- <template v-slot:prepend>
                                          <v-icon :color="getFuzzyColor(dropdownItem.raw)" size="18">
                                            {{ getFuzzyIcon(dropdownItem.raw) }}
                                          </v-icon>
                                        </template> -->

                                        <v-list-item-subtitle class="fuzzy-item-subtitle">
                                          {{ dropdownItem.raw.description }}
                                        </v-list-item-subtitle>
                                      </v-list-item>
                                    </template>

                                    <template v-slot:label>
                                      <div class="label-content">
                                        <!-- <v-icon size="16" class="mr-2" color="primary">mdi-tune</v-icon> -->
                                        <span>Fuzzy Matching</span>
                                      </div>
                                    </template>
                                  </v-select>

                                  <div class="personal-info-wrapper">
                                    <div class="personal-info-container">
                                      <div class="personal-info-header">
                                        <v-tooltip location="top" max-width="300px">
                                          <template v-slot:activator="{ props }">
                                            <div class="personal-info-label" v-bind="props">
                                              <v-img class="mr-2" :src="item.personalInformation ? images.vector : images.vectorinactive" width="18" height="18"></v-img>
                                              <span class="text-caption">
                                                Personal Info:
                                                <span :class="item.personalInformation ? 'status-on' : 'status-off'">
                                                  {{ item.personalInformation ? 'ON' : 'OFF' }}
                                                </span>
                                              </span>
                                            </div>
                                          </template>
                                          <span>{{ $t('_Personal_Info') }}</span>
                                        </v-tooltip>

                                        <v-switch
                                          v-model="item.personalInformation"
                                          id="personalinfo-add-internal-databaseintegration"
                                          inset
                                          density="compact"
                                          color="#C32E0E"
                                          hide-details
                                          class="personal-info-switch"
                                          :class="[
                                            'publication-toggle',
                                            item.personalInformation
                                              ? 'publication-toggle--active'
                                              : 'publication-toggle--inactive'
                                          ]"
                                          :disabled="
                                            item.typeId != null &&
                                            item.typeId.toLowerCase() != 'nvarchar' &&
                                            item.typeId.toLowerCase() != 'text' &&
                                            item.typeId.toLowerCase() != 'varchar' &&
                                            item.typeId.toLowerCase() != 'varchar2' &&
                                            item.typeId.toLowerCase() != 'char' &&
                                            item.typeId.toLowerCase() != 'nchar'
                                          "
                                        ></v-switch>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- <v-checkbox
                                    :id="`add-checkbox-fuzzy-dataIntegration-${index}`"
                                    v-model="item.fuzzy"
                                    @update:model-value="item.fuzzyBot = false"
                                    :disabled="item.typeId != 'nvarchar'"
                                    label="Fuzzy"
                                    color="primary"
                                    density="comfortable"
                                    hide-details
                                    class="modern-checkbox"
                                  ></v-checkbox>

                                  <v-checkbox
                                    :id="`add-checkbox-fuzzybot-dataIntegration-${index}`"
                                    v-model="item.fuzzyBot"
                                    @update:model-value="item.fuzzy = false"
                                    :disabled="
                                      requestDataIntegration.Type == 'I' &&
                                      item.typeId != 'nvarchar'
                                    "
                                    label="Fuzzy with bot"
                                    color="primary"
                                    density="comfortable"
                                    hide-details
                                    class="modern-checkbox"
                                  ></v-checkbox> -->
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- External System Configuration -->
                    <div v-show="requestDataIntegration.Type == 'E'" class="config-section">
                      <div class="section-container">

                        <div class="form-grid">
                          <v-text-field
                            id="add-tablename-external-dataIntegration"
                            v-model="requestDataIntegration.DataIntegrationName"
                            :rules="[rules.required]"
                            variant="outlined"
                            density="compact"
                            class="modern-input"
                            required
                          >
                            <template v-slot:label>
                              Table Name<span style="color: red;"> *</span>
                            </template>
                            <!-- <template v-slot:append-inner>
                              <v-tooltip :text="$t('_InfoDataIntegrationName')" location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon v-bind="props" size="16" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                                </template>
                              </v-tooltip>
                            </template> -->
                          </v-text-field>
                          <v-select
                            id="add-database-external-dataIntegration"
                            :items="DDDatabase"
                            item-title="name"
                            item-value="id"
                            @update:model-value="onInputConnectionString()"
                            v-model="requestDataIntegration.Database"
                            :rules="[rules.required]"
                            variant="outlined"
                            density="comfortable"
                            color="#C32E0E"
                            class="modern-input"
                            placeholder="Database *"
                            persistent-placeholder
                          >
                          <!-- <template v-slot:label>
                              Database<span style="color: red;"> *</span>
                          </template> -->
                            <!-- <template v-slot:append-inner>
                              <v-tooltip :text="$t('_InfoModel')" location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon v-bind="props" size="16" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                                </template>
                              </v-tooltip>
                            </template> -->
                          </v-select>
                        </div>

                        <v-text-field
                          id="add-connection-external-dataIntegration"
                          @input="onInputConnectionString()"
                          v-model="requestDataIntegration.ConnectionString"
                          :rules="[rules.required]"
                          variant="outlined"
                          density="comfortable"
                          class="modern-input full-width"
                        >
                          <template v-slot:label>
                              Connection String<span style="color: red;"> *</span>
                          </template>
                          <!-- <template v-slot:append-inner>
                            <v-tooltip :text="$t('_InfoConnectionString')" location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon v-bind="props" size="16" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                              </template>
                            </v-tooltip>
                          </template> -->
                        </v-text-field>

                        <div class="form-grid">
                          <v-text-field
                            id="add-schema-external-dataIntegration"
                            @input="onInputSchema()"
                            v-model="requestDataIntegration.Schema"
                            :rules="[rules.required]"
                            variant="outlined"
                            density="comfortable"
                            class="modern-input"
                          >
                            <template v-slot:label>
                              Schema<span style="color: red;"> *</span> 
                            </template>
                            <!-- <template v-slot:append-inner>
                              <v-tooltip :text="$t('_InfoSchema')" location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon v-bind="props" size="16" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                                </template>
                              </v-tooltip>
                            </template> -->
                          </v-text-field>

                          <v-text-field
                            id="add-view-external-dataIntergration"
                            v-model="requestDataIntegration.View"
                            :rules="[rules.required]"
                            variant="outlined"
                            density="comfortable"
                            class="modern-input"
                          >
                            <template v-slot:label>
                              View<span style="color: red;"> *</span>
                            </template>
                            <!-- <template v-slot:append-inner>
                              <v-tooltip :text="$t('_InfoTable')" location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon v-bind="props" size="16" color="grey-darken-1"> mdi-help-circle-outline </v-icon>
                                </template>
                              </v-tooltip>
                            </template> -->
                          </v-text-field>
                        </div>
                      <div class="headersection">
                        <v-tooltip text="Test Connection" location="top" v-if="requestDataIntegration.Type !== 'I'">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                id="button-test-connection-dataIntegration"
                                variant="outlined"
                                @click="TestConnection()"
                                class="dialog-action-btn test-btn"
                                v-bind="props"
                              >
                                <v-img :src="images.connectIcon" width="20" height="20" class="mr-2" />
                                <!-- <v-icon start>mdi-connection</v-icon> -->
                                Test Connection
                              </v-btn>
                            </template>
                        </v-tooltip>
                        <!-- checkbox get all colums outline -->
                        <v-checkbox
                          id="checkbox-get-all-columns-dataIntegration"
                          v-model="chkAllColumns"
                          label="Get All Columns"
                          color="#C32E0E"
                          density="comfortable"
                          hide-details
                          class="modern-checkbox"
                          v-if="requestDataIntegration.Type !== 'I'"
                        ></v-checkbox>
                      </div>

                      <v-divider class="header-divider mt-5"></v-divider>
                        <!-- External Columns -->
                        <div class="external-columns-section">
                          <div class="columns-header">
                            <h3 class="columns-title">Column Configuration</h3>
                            <v-btn id="add-column-external-dataIntegration" variant="text" prepend-icon="mdi-plus" @click="AddColumn()" class="add-column-btn">
                              Add Column
                              <v-tooltip activator="parent" location="top">Add Column Name </v-tooltip>
                            </v-btn>
                          </div>

                          <div class="external-columns-grid">
                            <v-card v-for="(item, index) in requestDataIntegration.Columns" :key="index" class="external-column-card" variant="outlined">
                              <v-card-text class="external-column-content">
                                <div class="external-column-header">
                                  <v-chip size="default" color="primary" variant="tonal">
                                    {{ index + 1 }}
                                  </v-chip>
                                  <v-btn
                                    :id="`add-deleteColumn-external-dataIntegration${index}`"
                                    icon
                                    variant="text"
                                    size="x-small"
                                    color="primary"
                                    @click="DeleteAction(index)"
                                    class="delete-column-btn"
                                  >
                                    <v-icon size="20">mdi-close</v-icon>
                                  </v-btn>
                                </div>

                                <v-text-field
                                  :id="`add-columnname-external-dataIntegration-${index}`"
                                  v-model="item.name"
                                  variant="outlined"
                                  density="comfortable"
                                  class="external-column-input modern-input"
                                  :error="errorMessages.columns[index]?.error"
                                  :error-messages="errorMessages.columns[index]?.message"
                                >
                                  <template v-slot:label>
                                      Column Name<span style="color: red;"> *</span>
                                    </template>
                                </v-text-field>

                                <!-- <v-checkbox
                                  :id="`add-checkbox-fuzzy-external-dataIntegration${index}`"
                                  v-model="item.fuzzy"
                                  @update:model-value="item.fuzzyBot = false"
                                  color="primary"
                                  density="comfortable"
                                  hide-details
                                  class="modern-checkbox"
                                >
                                  <template v-slot:label>
                                    <div class="checkbox-label">
                                      <span>Fuzzy</span>
                                      <v-tooltip :text="$t('_InfoFuzzy')" location="top">
                                        <template v-slot:activator="{ props }">
                                          <v-icon v-bind="props" size="14" color="grey-darken-1" class="ml-1"> mdi-help-circle-outline </v-icon>
                                        </template>
                                      </v-tooltip>
                                    </div>
                                  </template>
                                </v-checkbox> -->
                                <!-- <v-checkbox
                                  :id="`add-checkbox-fuzzy-external-dataIntegration${index}`"
                                  v-model="item.fuzzyBot"
                                  @update:model-value="item.fuzzy = false"
                                  color="primary"
                                  density="comfortable"
                                  hide-details
                                  class="modern-checkbox"
                                >
                                  <template v-slot:label>
                                    <div class="checkbox-label">
                                      <span>Fuzzy with bot</span>
                                      <v-tooltip :text="$t('_InfoFuzzyWithBot')" location="top">
                                        <template v-slot:activator="{ props }">
                                          <v-icon v-bind="props" size="14" color="grey-darken-1" class="ml-1"> mdi-help-circle-outline </v-icon>
                                        </template>
                                      </v-tooltip>
                                    </div>
                                  </template>
                                </v-select> -->
                                <div class="column-fields">
                                  <v-select
                                    :items="fuzzyOptions"
                                    item-title="text"
                                    item-value="value"
                                    variant="outlined"
                                    class="fuzzy-select modern-input"
                                    density="compact"
                                    hide-details
                                    @update:model-value="setFuzzyValue(item, $event)"
                                    :disabled="validateString(item)"
                                  >
                                    <!-- :disabled="type == 'I' && item.typeId != 'nvarchar'" -->
                                    <template v-slot:selection="{ item: selectedItem }">
                                      <div class="selection-content">
                                        <v-icon :color="getFuzzyColor(selectedItem.raw)" size="16" class="mr-2">
                                          {{ getFuzzyIcon(selectedItem.raw) }}
                                        </v-icon>
                                        <span class="selection-text">{{ selectedItem.raw.text }}</span>
                                      </div>
                                    </template>

                                    <template v-slot:item="{ props, item: dropdownItem }">
                                      <v-list-item v-bind="props" class="fuzzy-list-item">
                                        <template v-slot:prepend>
                                          <v-icon :color="getFuzzyColor(dropdownItem.raw)" size="18">
                                            {{ getFuzzyIcon(dropdownItem.raw) }}
                                          </v-icon>
                                        </template>

                                        <v-list-item-subtitle class="fuzzy-item-subtitle">
                                          {{ dropdownItem.raw.description }}
                                        </v-list-item-subtitle>
                                      </v-list-item>
                                    </template>

                                    <template v-slot:label>
                                      <div class="label-content">
                                        <span>Fuzzy Matching</span>
                                      </div>
                                    </template>
                                  </v-select>
                                  
                                  <div class="personal-info-wrapper">
                                    <div class="personal-info-container modern-input">
                                      <div class="personal-info-header">
                                        <v-tooltip location="top" max-width="320px">
                                          <template v-slot:activator="{ props }">
                                            <div class="personal-info-label" v-bind="props">
                                              <v-img class="mr-2" :src="item.personalInformation ? images.vector : images.vectorinactive" width="18" height="18"></v-img>
                                              <span class="text-caption" style="color: #646464!important">
                                                Personal Info:
                                                <span :class="item.personalInformation ? 'status-on' : 'status-off'">
                                                  {{ item.personalInformation ? 'ON' : 'OFF' }}
                                                </span>
                                              </span>
                                            </div>
                                          </template>
                                          <span>{{ $t('_Personal_Info') }}</span>
                                        </v-tooltip>

                                        <v-switch
                                          v-model="item.personalInformation"
                                          id="personalinfo-add-external-databaseintegration"
                                          inset
                                          density="compact"
                                          color="#C32E0E"
                                          hide-details
                                          class="personal-info-switch"
                                          :class="[
                                            'publication-toggle',
                                            item.personalInformation
                                              ? 'publication-toggle--active'
                                              : 'publication-toggle--inactive'
                                          ]"
                                          :disabled="
                                            validateString(item)
                                          "
                                        ></v-switch>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card-text>

                  <v-divider></v-divider>

                  <!-- Enhanced Actions -->
                  <div class="dialog-actions">
                    <div class="actions-content d-flex justify-end">
                      <div class="actions-right">
                        <v-btn variant="outlined" color="grey-darken-1" @click="closeDialogAddDataIntegration" class="dialog-action-btn cancel-btn"> Cancel </v-btn>
                        <v-btn
                          variant="flat"
                          @click="requestDataIntegration.Type === 'I' ? ConfirmProcess('I') : ConfirmProcess('E')"
                          class="dialog-action-btn savebtn"
                          :disabled="!requestDataIntegration.DataIntegrationName"
                        >
                          <v-img :src="images.saveImg" width="20" height="20" class="mr-2"/>
                          Save Table
                        </v-btn>
                      </div>
                    </div>
                  </div>
                  <!-- <v-card-actions class="modern-actions">
                    <v-spacer></v-spacer>
                    <v-btn
                      variant="text"
                      color="grey-darken-1"
                      @click="AddDataIntegration = false"
                      class="action-btn cancel-btn"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      color="success"
                      variant="flat"
                      @click="
                        requestDataIntegration.Type === 'I'
                          ? ConfirmProcess('I')
                          : ConfirmProcess('E')
                      "
                      class="action-btn save-btn"
                      :disabled="!requestDataIntegration.DataIntegrationName"
                    >
                      <v-icon start>mdi-content-save</v-icon>
                      Save Configuration
                    </v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server class="tablelist mt-4 px-6" v-model:options="options" :items-per-page="itemsPerPage" :items-length="searchTotalTable" :items="dataTable" :headers="headers" :loading="loadingTable">
          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: center">{{ item.number }}</td>
              <td>{{ item.dataName }}</td>
              <td style="text-align: left">{{ item.type === 'Internal' ? 'File Import' : 'Database Connection' }}</td>
              <td style="text-align: center">{{ item.createBy }}</td>
              <td style="text-align: center">
                <div class="action-group" style="justify-content: center">
                  <!-- Edit -->
                  <v-btn id="button-edit-uploadCSV" variant="text" density="comfortable" @click="Edit(item)" class="action-btn" icon>
                    <!-- <v-icon size="18">mdi-pencil-outline</v-icon> -->
                    <v-img :src="images.editBtn" width="20" height="20" />
                  </v-btn>
                  <!-- Delete -->
                  <v-btn 
                  id="button-delete-uploadCSV" 
                  variant="text" 
                  density="comfortable" 
                  @click="Delete(item.id)" 
                  class="action-btn" 
                  icon
                  :disabled="btnDisableDelete(item)"
                  >
                    <!-- <v-icon size="18">mdi-delete-outline</v-icon> -->
                    <v-img :src="images.deleteBtn" width="20" height="20" />
                    <!-- <v-tooltip activator="parent" location="top">
                      Delete
                    </v-tooltip> -->
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
          <!-- 👇 Custom footer area -->
          <template v-slot:bottom>
            <div
              class="d-flex justify-space-between align-center px-4 py-2"
              style="width: 100%"
            >
              <div>Total results {{ searchTotalTable }}</div>

              <v-data-table-footer
                :items-per-page-options="[10, 20, 50]"
                v-model:items-per-page="itemsPerPage"
                :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)"
              />
            </div>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>
    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">Delete table</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelDelete"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span v-if="deleteItem">
            Are you sure you want to delete this table? This action cannot be undone.
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelDelete"
          >
            Cancel
          </v-btn>
          <v-btn
            class="delete-confirm-btn"
            @click="confirmDelete"
          >
            <v-img :src="images.deleteIcon" width="20" height="20" class="mr-2"/>
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- loading -->
    <v-overlay :model-value="dialog" class="align-center justify-center">
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import checkPermissionTwo from '@/api/function.js';
import dateUtils from '../plugins/date-utils';
import DragDropFile from '@/components/DragDropFile.vue';
import ExcelJS from 'exceljs';
import moment from 'moment';
import editImg from '@/assets/edit1.png';
import deleteImg from '@/assets/delete1.png';
import editBtn from '@/assets/images/editbutton.png';
import deleteBtn from '@/assets/images/trashbutton.png';
import infoactive from '@/assets/images/infoactive.png';
import info from '@/assets/images/info.png';
import plusIcon from '@/assets/images/round-plus.png';
import connectIcon from '@/assets/images/connection.png';
import vector from '@/assets/images/Vector.png';
import vectorinactive from '@/assets/images/Vectorinactive.png';
import excelImg from '@/assets/images/file-excel.png';
import saveImg from '@/assets/images/savecard.png';
import uploadexcelImg from '@/assets/Icons/uploadexcel.png';
import deleteIcon from "@/assets/images/trash-solid.svg";

export default {
  name: 'DataIntegration',
  inject: [
    'flagNav',
    "FontColorTitle",
    'SubNavbarBackGround',
    'Username',
    'RoleId'
  ],
  components: { DragDropFile },
  mixins: [checkPermissionTwo],
  data: () => ({
    today: null,
    accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    searchDataIntegrationName: null,
    AddDataIntegration: false,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dataTable: [],
    itemsPerPage: 10,
    searchTotalTable: 0,
    totalTable: 0,
    dialog: false,
    files: [],
    dialog_delete: false,
    deleteItem: null,
    uploadedFiles: [],
    chkAllColumns: false,
    requestDataIntegration: {
      entity: null,
      DataIntegrationName: null,
      ConnectionString: '',
      Schema: '',
      View: '',
      Columns: [{ name: '', typeId: 'nvarchar', fuzzy: false, fuzzyBot: false }],
      Type: 'I',
      Database: null,
    },
    DataRowUpload: [],
    DDDataType: [
      {
        id: 'nvarchar',
        name: 'nvarchar',
      },
      {
        id: 'int',
        name: 'int',
      },
      {
        id: 'float',
        name: 'float',
      },
      {
        id: 'datetime',
        name: 'datetime',
      },
      {
        id: 'bit',
        name: 'bit',
      },
    ],
    DDDatabase: [
      {
        id: '1',
        name: 'SQL Server',
      },
      {
        id: '2',
        name: 'Oracle',
      },
      {
        id: '3',
        name: 'Postgresql',
      },
      {
        id: '4',
        name: 'Mysql',
      },
      {
        id: '5',
        name: 'Snowflake',
      },
    ],
    rules: {
      required: (value) => !!value || 'Required.',
    },
    images: {
      edit: editImg,
      delete: deleteImg,
      editBtn: editBtn,
      deleteBtn: deleteBtn,
      infoactive: infoactive,
      info: info,
      plusIcon: plusIcon,
      connectIcon: connectIcon,
      vectorinactive: vectorinactive,
      vector: vector,
      excelImg: excelImg,
      saveImg: saveImg,
      uploadexcelImg: uploadexcelImg,
      deleteIcon: deleteIcon,
    },
    sortBy: [],
    sortDesc: [],
    isFirst: true,
    isSearch: false,
    defaultFuzzy: 'none', // Default fuzzy option
    fuzzyOptions: [
      {
        text: 'None',
        value: 'none',
        description: 'No fuzzy matching applied',
        icon: 'mdi-close-circle-outline',
        color: 'grey',
      },
      {
        text: 'Fuzzy Search',
        value: 'fuzzy',
        description: 'Enable approximate text matching for this column',
        icon: 'mdi-magnify',
        color: 'primary',
      },
      {
        text: 'Fuzzy with Bot',
        value: 'fuzzyBot',
        description: 'AI-powered smart matching with enhanced accuracy',
        icon: 'mdi-robot',
        color: 'success',
      },
    ],
    errorMessages: {
      columns: [
        {
          error: false,
          message: '',
        },
      ],
    },
  }),
  computed: {
    headers() {
      return [
        {
          title: this.$t('no'),
          align: 'center',
          sortable: false,
          width: '120px',
          minWidth: '80px',
        },
        {
          title: 'Table Name',
          value: 'Name',
          align: 'left',
          sortable: true,
          width: 'auto',
          minWidth: '200px',
        },
        {
          title: 'Import Type',
          value: 'System',
          align: 'left',
          sortable: true,
          width: '300',
          minWidth: '100px',
        },
        {
          title: 'Created by',
          value: 'CreateBy',
          align: 'center',
          sortable: true,
          width: '150px',
          minWidth: '120px',
        },
        {
          title: 'Manage',
          align: 'center',
          sortable: false,
          width: '150px',
        },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    closeDialogAddDataIntegration() {
      this.AddDataIntegration = false;
      this.errorMessages.columns = [{ error: false, message: '' }];
    },
    btnDisableDelete(item) {
      if ((this.RoleId == 2 || this.RoleId == 6) && item.createBy != this.Username) {
        return true;
      }
      return false;
    },
    validateString(item) {
      if (this.requestDataIntegration.Type === 'E') {
        const stringTypes = ['nvarchar', 'text', 'varchar', 'varchar2', 'char', 'nchar', 'TEXT', 'VARCHAR2', 'CHAR', 'NCHAR', 'NVARCHAR2'];
        return !stringTypes.includes(item.typeId);
      }
    },
    setFuzzyValue(item, value) {
      // Reset all fuzzy options
      item.fuzzy = false;
      item.fuzzyBot = false;

      // Set the selected option
      if (value === 'fuzzy') {
        item.fuzzy = true;
      } else if (value === 'fuzzyBot') {
        item.fuzzyBot = true;
      }
    },
    getFuzzyColor(itemOrOption) {
      if (itemOrOption.color) return itemOrOption.color; // For dropdown options

      // For actual items
      if (itemOrOption.fuzzy) return 'primary';
      if (itemOrOption.fuzzyBot) return 'success';
      return 'grey';
    },
    getFuzzyIcon(itemOrOption) {
      if (itemOrOption.icon) return itemOrOption.icon; // For dropdown options

      // For actual items
      if (itemOrOption.fuzzy) return 'mdi-magnify';
      if (itemOrOption.fuzzyBot) return 'mdi-robot';
      return 'mdi-close-circle-outline';
    },
    Get() {
      let self = this;
      // self.dialog = true;
      self.loadingTable = true;

      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        DataName: self.searchDataIntegrationName,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableDataIntegration(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    triggerFileUpload() {
      // เรียก method click ของ DragDropFile component
      if (this.$refs.dragDropRef) {
        // หาปุ่ม upload ใน DragDropFile component และคลิก
        const uploadButton = this.$refs.dragDropRef.$el.querySelector('input[type="file"]');
        if (uploadButton) {
          this.errorMessages.columns.push({ error: false, message: '' });
          uploadButton.click();
        }
      }
    },
    Search() {
      let self = this;
      self.options.page = 1;
      self.Get();
    },
    Save() {
      let self = this;
      let tempCheckColumns = [];
      let headers = [];
      let listindexnamefuzzy = [];
      let columnData = [];
      let spaceText = false;
      self.requestDataIntegration.Columns.forEach((item,index) => {
        // validate Column ' abc defg '
        const splitText = item.name.split(' ');
        if (this.errorMessages.columns[index]) {
          this.errorMessages.columns[index].error = false;
          this.errorMessages.columns[index].message = '';
        }

        if (splitText.length > 1 && (splitText[0] === '' || splitText[splitText.length - 1] === '')) {
          if (!this.errorMessages.columns[index]) {
            this.errorMessages.columns[index] = { error: false, message: '' };
          }
          
          this.errorMessages.columns[index].error = true;
          this.errorMessages.columns[index].message = 'Column name cannot have leading or trailing spaces!';
          spaceText = true;
        }

        if (item.name !== null && item.name !== undefined && item.name !== '' && item.typeId !== null && item.typeId !== undefined && item.typeId !== '') {
          tempCheckColumns.push(item);
          headers.push(item.name);
        }
        if (item.fuzzy == true || item.fuzzyBot == true) {
          let index = headers.indexOf(item.name);
          listindexnamefuzzy.push(index);
        }
      });

      if (spaceText) {
        return
      }

      if (self.ValidateColumns(headers, columnData)) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('_duplicateColumn'),
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }

      if (!self.requestDataIntegration.DataIntegrationName || tempCheckColumns.length < 1 || self.requestDataIntegration.Columns.length != tempCheckColumns.length) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warningFillAll'),
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }

      self.requestDataIntegration.Columns = tempCheckColumns;
      let chkValidateLimitFuzzy = self.ValidateLimitFuzzy(headers, listindexnamefuzzy);
      if (chkValidateLimitFuzzy != null) {
        self.$swal.fire({
          icon: 'warning',
          title: chkValidateLimitFuzzy,
          showConfirmButton: true,
        });
        return;
      }
      self.dialog = true;
      let temp = {
        ReqData: self.requestDataIntegration,
        uploaded_file: self.requestDataIntegration.entity,
      };
      try {
        self.$call.AddDataIntegration_Table(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.Get();
              self.SaveData(dataResponse.data);
            } else {
              self.$swal.fire({
                icon: 'error',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 2500,
              });
              self.dialog = false;
            }
          },
          (errorResource) => {
            self.dialog = false;
            self.AddVector = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    SaveData(id) {
      let self = this;
      self.dialog = true;
      let temp = {
        id,
        uploaded_file: self.requestDataIntegration.entity,
        deleteAll: false,
      };
      try {
        self.$call.AddDataIntegration_Data(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                title: "✔ " + dataResponse.message + " uploaded",
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                },
              });
              self.AddDataIntegration = false;
              self.requestDataIntegration.DataIntegrationName = null;
              // self.Get();
            } else {
              self.$swal.fire({
                icon: 'error',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 2500,
              });
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.AddVector = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    back(e) {
      if (e) {
        this.EditdialogUser = false;
        this.AddVector = false;
      }
    },
    Delete(id) {
      let self = this;
      self.deleteItem = id;
      self.dialog_delete = true;
      
    },
    cancelDelete() {
      this.dialog_delete = false;
      this.deleteItem = null;
    },
    confirmDelete() {
      let self = this;
      if (!self.deleteItem) return;
      var id = self.deleteItem
      try {
        self.dialog_delete = false;
        self.dialog = true;
        
        self.$call.DeleteDataIntegration(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      title: "✔ Successfully Deleted !",
                      showConfirmButton: false,
                      timer: 1500,
                      customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                    });
                    self.Get();
                  }else if (dataResponse.status == 1) {
                    self.$swal.fire({
                      icon: "error",
                      title: dataResponse.message,
                      showConfirmButton: true,
                      confirmButtonText: this.$t("gotIt"),
                      confirmButtonColor: "#d33",
                    });
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  console.error(errorResource);
                }
              );
              
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    Add() {
      let self = this;
      self.AddDataIntegration = true;
      self.uploadedFiles = [];
      self.requestDataIntegration.Columns = [];
    },
    Edit(item) {
      let self = this;
      self.$router.push({
        name: 'DataIntegrationDetail',
        query: {
          id: item.id,
          type: item.type,
        },
      });
    },
    convertDateToString(date, seperator = '/') {
      return dateUtils.getStringWithTimeFromDate(moment(date).toDate(), seperator);
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!
      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      this.today = dd + '/' + mm + '/' + yyyy;
    },
    // async AutoRefresh() {
    //   let self = this;
    //   let death_waiting = true;
    //   do {
    //     for (let value of self.dataTable) {
    //       if (value.inProcess < value.inProcessMax && !value.isError) {
    //         self.ReFreshGet();
    //         death_waiting = true;
    //         break;
    //       } else {
    //         death_waiting = false;
    //       }
    //     }
    //     if (window.location.pathname != '/VectorManagement') {
    //       death_waiting = false;
    //     }
    //     console.log('Wait for 5 seconds!');
    //     await new Promise((resolve) => setTimeout(resolve, 5000));
    //   } while (death_waiting);
    // },
    getColumnData(dataRows) {
      const dataTypes = [];
      dataRows[0].forEach((_, colIndex) => {
        // เก็บข้อมูลชนิดต่างๆ ที่พบในคอลัมน์
        let hasString = false;
        let hasFloat = false; 
        let hasInteger = false;
        let hasBoolean = false;
        let hasDate = false;
        
        // วนลูปเช็คข้อมูลทั้งหมดในคอลัมน์
        for (let i = 0; i < dataRows.length; i++) {
          const value = dataRows[i][colIndex];
          if (value instanceof Date && !isNaN(value)) {
            hasDate = true;
          } else if (typeof value === 'boolean') {
            hasBoolean = true;
          } else if (Number.isInteger(value)) {
            hasInteger = true;
          } else if (typeof value === 'number') {
            hasFloat = true;
          } else if (typeof value === 'string') {
            // ตรวจสอบว่า string นี้เป็นตัวเลขหรือไม่
            const numValue = Number(value);
            if (!isNaN(numValue) && isFinite(numValue)) {
              if (Number.isInteger(numValue)) {
                hasInteger = true;
              } else {
                hasFloat = true;
              }
            } else {
              hasString = true;
            }
          } else {
            hasString = true;
          }
        }
        
        // กำหนด data type ตามลำดับความเหมาะสม
        let detectedType = 'nvarchar'; // ค่าเริ่มต้น
        
        if (hasString) {
          detectedType = 'nvarchar'; // ถ้ามี string เลยเป็น nvarchar
        } else if (hasDate) {
          detectedType = 'datetime'; // ถ้ามี date
        } else if (hasFloat) {
          detectedType = 'float'; // ถ้ามี float (รวมถึงกรณี int+float)
        } else if (hasInteger) {
          detectedType = 'int'; // ถ้ามีแต่ integer
        } else if (hasBoolean) {
          detectedType = 'bit'; // ถ้ามีแต่ boolean
        }       
        dataTypes.push(detectedType);
      });
      return dataTypes;
    },
    processUpload(e) {
      let self = this;
      this.files = e;
      if (this.files.length == 0) {
        this.requestDataIntegration.entity = null;
        this.uploadedFiles = [];
        return;
      }
      const reader = new FileReader();
      const file = this.files[0];
      reader.onload = async (event) => {
        const buffer = event.target.result;
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(buffer);

        // Get the first worksheet
        const worksheet = workbook.getWorksheet(1);
        if (!worksheet) {
          self.$swal.fire({
            icon: 'error',
            title: 'No worksheet found in the Excel file',
            showConfirmButton: false,
            timer: 2500,
          });
          return;
        }

        // Extract data from the worksheet
        const jsonData = [];
        const headers = [];

        // Get headers from the first row
        worksheet.getRow(1).eachCell((cell, colNumber) => {
          headers.push(cell.value);
        });
        jsonData.push(headers);

        // Get data from remaining rows
        worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
          if (rowNumber === 1) return; // Skip header row

          const rowData = [];
          row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            rowData[colNumber - 1] = cell.value;
          });

          // Ensure rowData has the same length as headers
          while (rowData.length < headers.length) {
            rowData.push('');
          }

          jsonData.push(rowData);
        });

        self.DataRowUpload = jsonData.slice(1);
        const columnData = self.getColumnData(self.DataRowUpload);

        if (self.ValidateColumns(headers, columnData)) {
          self.$swal.fire({
            icon: 'error',
            title: self.$t('_duplicateColumn'),
            showConfirmButton: false,
            timer: 2500,
          });
        } else {
          this.MapData(self.files);
        }
      };
      reader.readAsArrayBuffer(file);
    },
    ValidateLimitFuzzy(headers, listindexnamefuzzy) {
      let self = this;
      for (let j = 0; j < listindexnamefuzzy.length; j++) {
        let indexcol = listindexnamefuzzy[j];
        for (let i = 0; i < self.DataRowUpload.length; i++) {
          let tmpdata = self.DataRowUpload[i][indexcol];
          if (tmpdata.length > 800) {
            return 'The data in column ' + headers[indexcol] + ', row ' + (i + 2) + ' exceeds the limit of 800 characters.';
          }
        }
      }
      return null;
    },
    ValidateColumns(columns, columnData) {
      let self = this;

      const uniqueColumns = [...new Set(columns)];
      if (uniqueColumns.length !== columns.length) {
        return true; //มี Header ซ้ำ
      } else {
        self.requestDataIntegration.Columns = [];
        self.requestDataIntegration.Columns = columns.map((item, index) => ({
          name: item,
          typeId: columnData[index],
          fuzzy: false,
          fuzzyBot: false,
        }));
        return false;
      }
    },
    MapData(files) {
      const formDataDoc = new FormData();
      formDataDoc.append('uploaded_file', files[0]);
      //console.log(files[0]);
      this.uploadedFiles = files;
      this.requestDataIntegration.entity = formDataDoc;
    },
    ConfirmProcess(type) {
      let self = this;
      self.$swal
        .fire({
          icon: 'warning',
          title: this.$t('ConfirmDataAddition'),
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('cancel'),
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (type == 'I') {
              self.totalTable = self.totalTable + 1;
              self.Save();
            } else if (type == 'E') {
              self.totalTable = self.totalTable + 1;
              self.AddDataIntegrationConnection();
            }
          }
        });
    },
    TestConnection() {
      let self = this;
      if (!self.requestDataIntegration.ConnectionString) {
        self.$swal.fire({
          icon: 'warning',
          title: 'Please fill in information Connection String!',
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      if (self.chkAllColumns) {
        if (self.requestDataIntegration.Schema == '' || self.requestDataIntegration.Schema == null) {
          alert('Please fill in information Schema!');
          return;
        }
        if (self.requestDataIntegration.View == '' || self.requestDataIntegration.View == null) {
          alert('Please fill in information View!');
          return;
        }
      }
      self.dialog = true;
      
      if (!self.chkAllColumns) {
        if (self.requestDataIntegration.Columns.some((col) => col.name.trim() === '')) {
          self.$swal.fire({
            icon: 'warning',
            title: 'Please fill in all column names!',
            showConfirmButton: false,
            timer: 2500,
          });
          self.dialog = false;
          return;
        }
      }
      let cols = self.requestDataIntegration.Columns.map((col) => col.name);
      let temp = {
        ConnectionString: self.requestDataIntegration.ConnectionString,
        Schema: self.requestDataIntegration.Schema,
        View: self.requestDataIntegration.View,
        Database: self.requestDataIntegration.Database,
        chkAllColumns: self.chkAllColumns,
        ColumnChecklist: cols
      };
      self.$call.TestConnection(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.GetALLColumnByTestConnection(dataResponse.data.columns);
            self.$swal.fire({
              icon: 'success',
              title: dataResponse.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            self.$swal.fire({
              icon: 'error',
              title: dataResponse.data.message,
              showConfirmButton: true,
              confirmButtonText: 'Okay',
            });
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    AddColumn() {
      let self = this;

      let temp = {
        name: '',
        fuzzy: false,
        fuzzyBot: false,
      };
      self.requestDataIntegration.Columns.push(temp);
      self.errorMessages.columns.push({ error: false, message: '' });
    },
    GetALLColumnByTestConnection(listColumns) {
      let self = this;
      self.requestDataIntegration.Columns = [];
      listColumns.forEach((columnName) => {
        let temp = {
          name: columnName.name, // นำ columnName ใส่ใน temp.name
          // dataType : columnName.dataType, // นำ columnName.dataType ใส่ใน temp.dataType
          typeId: columnName.dataType, // นำ columnName.dataType ใส่ใน temp.typeId
          fuzzy: false,
          fuzzyBot: false,
          personalInformation: false,
        };
        self.requestDataIntegration.Columns.push(temp);
      });
    },
    DeleteAction(index) {
      let self = this;
      if (index > -1 && index < self.requestDataIntegration.Columns.length) {
        self.requestDataIntegration.Columns.splice(index, 1);
        self.errorMessages.columns.splice(index, 1);
      }
    },
    ClearPopupAddDataIntegration() {
      let self = this;
      self.requestDataIntegration.entity = null;
      self.requestDataIntegration.DataIntegrationName = null;
      self.requestDataIntegration.ConnectionString = '';
      self.requestDataIntegration.Schema = '';
      self.requestDataIntegration.View = '';
      self.requestDataIntegration.Columns = [{ name: '', fuzzy: false, fuzzyBot: false }];
      self.requestDataIntegration.Type = 'I';
    },
    ClearPopupWhenChange() {
      let self = this;
      self.requestDataIntegration.entity = null;
      self.requestDataIntegration.DataIntegrationName = null;
      self.requestDataIntegration.ConnectionString = '';
      self.requestDataIntegration.Schema = '';
      self.requestDataIntegration.View = '';
      self.requestDataIntegration.Columns = [{ name: '', fuzzy: false, fuzzyBot: false }];
      self.errorMessages.columns = [{ error: false, message: '' }];
    },
    AddDataIntegrationConnection() {
      let self = this;
      let tempCheckColumns = [];
      let headers = [];
      let columnData = [];
      let spaceText = false;
      self.requestDataIntegration.Columns.forEach((item,index) => {
        // Ensure errorMessages.columns array has enough elements
        if (!this.errorMessages.columns[index]) {
          this.errorMessages.columns[index] = { error: false, message: '' };
        }
        
        this.errorMessages.columns[index].error = false;
        this.errorMessages.columns[index].message = '';
        
        // Check if item.name exists and is a string before splitting
        if (item.name && typeof item.name === 'string') {
          const splitText = item.name.split(' ');
          if (splitText.length > 1 && (splitText[0] === '' || splitText[splitText.length - 1] === '')) {
            this.errorMessages.columns[index].error = true;
            this.errorMessages.columns[index].message = 'Column name cannot have leading or trailing spaces!';
            spaceText = true;
          }
        }
        
        if (item.name !== null && item.name !== undefined && item.name !== '') {
          tempCheckColumns.push(item);
          headers.push(item.name);
        }
      });

      if (spaceText) {
        return;
      }

      if (self.ValidateColumns(headers, columnData)) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('_duplicateColumn'),
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }

      if (
        !self.requestDataIntegration.DataIntegrationName ||
        !self.requestDataIntegration.ConnectionString ||
        !self.requestDataIntegration.Schema ||
        !self.requestDataIntegration.View ||
        !self.requestDataIntegration.Database ||
        tempCheckColumns.length < 1
      ) {
        self.$swal.fire({
          icon: 'warning',
          title: 'Please Fill All The Fields!',
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      self.dialog = true;
      self.requestDataIntegration.Columns = tempCheckColumns;
      self.$call.AddDataIntegrationConnection(
        self.requestDataIntegration,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: 'success',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 1500,
            });
            self.AddDataIntegration = false;
            self.ClearPopupAddDataIntegration();
            self.Get();
          } else {
            self.$swal.fire({
              icon: 'error',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 2500,
            });
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.AddDataIntegration = false;
          console.error(errorResource);
        }
      );
    },
    setDefault(item) {
      item.fuzzy = false;
      item.fuzzyBot = false;
    },
    onInputSchema() {
      let self = this;
      if (self.requestDataIntegration.Database == '5') {
        const cs = self.requestDataIntegration.ConnectionString || '';
        const newSchema = (self.requestDataIntegration.Schema || '').trim();
        let updatedCS;

        // ถ้ามี key schema อยู่๝ล้ว ให้ replace ค่า
        if (/(^|;)schema=[^;]*/i.test(cs)) {
          updatedCS = cs.replace(/(^|;)schema=[^;]*/i, `$1schema=${newSchema}`);
        } else {
          updatedCS = cs ? `${cs.replace(/;$/, '')};schema=${newSchema}` : `schema=${newSchema}`;
        }

        self.requestDataIntegration.ConnectionString = updatedCS;
      }
    },
    onInputConnectionString() {
      let self = this;
      if (self.requestDataIntegration.Database == '5') {
        const cs = self.requestDataIntegration.ConnectionString || '';
        const schema = this.extractSchema(cs);
        if (schema) {
          self.requestDataIntegration.Schema = schema;
        }
      }
    },
    extractSchema(connectionString) {
      const match = connectionString.match(/(?:^|;)schema=([^;]+)/i);
      return match ? match[1].trim() : '';
    },
  },
  mounted() {
    this.GetDate();
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.card {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.tablelist{
  padding: 0px 20px;
  overflow: hidden; 
}
.tablelist .v-data-table__thead {
  background-color: #FFF2F2!important;
  border-radius: 16px 16px 0 0!important;
}

/* Card section */
.headersection {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cardButton{
  padding: 8px;
  width: 54%;
  border-radius: 15px;
}
.custom-toggle {
  border-radius: 10px;
  overflow: hidden;
}

/* Buttons inside the toggle */
.custom-toggle .v-btn {
  text-transform: none;
  font-weight: bold;
  color: #333;
  border-radius: 10px;
  margin-right: 10px;
}
:deep(.custom-toggle .v-btn .v-btn__content){
  font-weight: 600!important;
}

/* Remove border from the last button */
.custom-toggle .v-btn:last-child {
  border-right: none;
}

/* Active button style */
.custom-toggle .v-btn.v-btn--active {
  background-color: #001763;
  color: #FFFFFF;
}

/* Optional hover effect */
.custom-toggle .v-btn:hover {
  background-color: #001765;
  color: #FFFFFF;
}
.savebtn {
  background: linear-gradient(135deg, #C32E0E 0%, #F67760 100%);
  color: white !important;
}
.custom-search-input-wrapper {
  width: 100%;
  max-width: 320px;
}
:deep(thead) {
  background-color: #FFE4E1 !important;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.custom-table .v-data-table-header {
  background-color: #f5f7fa!important;
  color: #333;
}
/* Dropdown items per page */
:deep(.v-data-table-footer .v-field) {
  border-radius: 10px !important;
  width: 70px !important;
}
:deep(.v-data-table-footer .v-select) {
  width: 80px !important;
}

.config-input {
    margin-bottom: 0px;
}

.config-input :deep(.v-field) {
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
}

.config-input :deep(.v-field:hover) {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}
.publication-toggle {
  margin: 0 4px;
}

.publication-toggle :deep(.v-switch__track) {
  transform: scale(0.8);
  width: 40px;
  height: 28px;
  border-radius: 999px;
  border: 2px solid transparent;
  background-color: transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.publication-toggle :deep(.v-switch__thumb) {
  width: 20px;
  height: 20px;
  box-shadow: none;
  border: 2px solid transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.publication-toggle--active :deep(.v-switch__track) {
  background-color: #ffffff !important;
  border-color: #d32f2f;
}

.publication-toggle--active :deep(.v-switch__thumb) {
  background-color: #d32f2f !important;
  border-color: #d32f2f;
  transform: translateX(-0.5px);
}

.publication-toggle--inactive :deep(.v-switch__track) {
  background-color: #bdbdbd !important;
  border-color: #bdbdbd;
}

.publication-toggle--inactive :deep(.v-switch__thumb) {
  background-color: #ffffff !important;
  border-color: #bdbdbd;
  width: 30px;
  height: 30px;
}
.savebtn:disabled {
  background: rgba(246, 119, 96, 0.5) !important;
  color: rgba(255, 255, 255, 0.7) !important;
}
.test-btn{
  border: 1px solid #3859D0;
  color: #3859D0 !important;
  background: #E7EBFF;
}
/* Table improvements */
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table__wrapper) {
  border-radius: 12px;
}

:deep(.v-data-table tbody tr) {
  transition: background-color 0.2s ease;
}

:deep(.v-data-table tbody tr:hover) {
  background-color: rgba(0, 0, 0, 0.02) !important;
}

:deep(.v-data-table-header) {
  background: rgba(0, 0, 0, 0.02);
}

:deep(.v-data-table-header th) {
  font-weight: 600 !important;
  color: rgba(0, 0, 0, 0.7) !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.025em !important;
}

/* Search panel improvements */
.search-panel {
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  border-radius: 12px !important;
  background: rgba(0, 0, 0, 0.01);
}

/* Header improvements */
:deep(.v-toolbar) {
  border-radius: 12px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12) !important;
}

/* Dialog improvements */
:deep(.v-dialog .v-card) {
  border-radius: 16px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .action-controls {
    width: 100%;
    justify-content: center;
    min-width: auto;
  }

  .control-btn {
    flex: 1;
  }
}

/* Smooth animations */
* {
  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

/* Loading states */
.v-skeleton-loader {
  border-radius: 12px !important;
}

/* Focus states */
.control-btn:focus-visible {
  outline: 2px solid rgb(25, 118, 210);
  outline-offset: 2px;
}

/* Custom scrollbar */
:deep(.v-data-table__wrapper)::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-track {
  background: transparent;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.AddColumn:hover {
  background-color: #1976d2 !important;
  color: white !important;
}

::v-deep.UploadFile .NoDragDrop button.v-btn {
  margin: 0px !important;
}

.middle4 {
  position: absolute;
  right: 3px;
  top: 18px;
  transform: translateY(-50%);
  opacity: 0;
  transition: 0.2s ease;
}

.Card-Action {
  padding: 0 5px 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
  position: relative;
  margin-bottom: 5px;
}

.Card-Action:hover .middle4 {
  opacity: 1;
}
/* Action Divider */
.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.1);
  margin: 0 12px;
  align-self: center;
  border-radius: 1px;
}

.dialog-container :deep(.v-overlay__content) {
  margin: 24px;
  max-height: calc(100vh - 48px);
  overflow-y: auto;
}

.modern-card {
  border-radius: 20px !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid rgba(0, 0, 0, 0.04);
  background: #ffffff;
}

/* Enhanced Header */
.modern-header {
  padding: 24px 24px 16px 24px;
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.02) 0%, rgba(25, 118, 210, 0.01) 100%);
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: rgba(25, 118, 210, 0.1);
  border-radius: 12px;
}

.header-text {
  flex: 1;
}

.title-text {
  font-size: 1.5rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
  margin: 0;
  line-height: 1.2;
}

.subtitle-text {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  margin: 4px 0 0 0;
  line-height: 1.2;
}

.close-btn {
  opacity: 0.7;
  transition: all 0.2s ease;
}

.close-btn:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.04);
}

.header-divider {
  opacity: 1;
}

/* Content Section */
.modern-content {
  padding: 24px;
  max-height: 60vh;
  overflow-y: auto;
}

.section-container {
  margin-bottom: 32px;
}

.section-container:last-child {
  margin-bottom: 0;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.section-icon {
  opacity: 0.8;
}

.section-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
}

/* Radio Group Modern */
.radio-group-modern {
  margin-top: 8px;
}

.radio-options {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.radio-option {
  flex: none;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

.radio-icon {
  opacity: 0.7;
}

/* Configuration Sections */
.config-section {
  animation: fadeInUp 0.3s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Form Grid */
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group-large {
  grid-column: 1 / -1;
}

.full-width {
  grid-column: 1 / -1;
}

.upload-section {
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
}

.modern-upload {
  flex: 1;
}

.upload-section {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

/* .upload-container {
  position: relative;
  width: 100%;
  max-width: 400px;
} */

.upload-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px 24px;
  border: 1px dashed #949AA8;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(255, 242, 242, 1) 0%, rgba(255, 255, 255, 1) 100%);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  width: 100% !important;
}

.upload-area::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 242, 242, 01) 50%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.upload-area:hover {
  border-color:  rgba(255, 242, 242, 1);
  background: linear-gradient(135deg, rgba(255, 242, 242, 1) 0%, rgba(255, 255, 255, 1) 100%);
  /* transform: translateY(-2px); */
  box-shadow: 0 6px 15px rgb(251, 236, 236);
}

.upload-area:hover::before {
  opacity: 1;
}

/* Main Upload Button */
.upload-main-btn {
  position: relative;
  z-index: 2;
  border-radius: 12px !important;
  /* font-weight: 600 !important; */
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  padding: 0 24px !important;
  height: 48px !important;
  background-color: transparent !important;
  border: 1px solid rgba(195, 46, 14, 0.8) !important ;
  color:#C32E0E ;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

.upload-main-btn:hover {
  box-shadow: 0 6px 20px rgba(195, 46, 14, 0.35) !important;
  transform: translateY(-1px);
}

.upload-main-btn:active {
  transform: translateY(0);
}

.upload-text {
  font-size: 1rem;
  font-weight: 400;
}

/* Upload Info Section */
.upload-info {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  z-index: 2;
}

.upload-description {
  display: flex;
  align-items: center;
  gap: 4px;
}

.upload-hint {
  font-size: 0.875rem;
  color: #646464;
  font-weight: 500;
}

.upload-help-btn {
  opacity: 0.7;
  transition: all 0.2s ease;
}

.upload-help-btn:hover {
  opacity: 1;
  background: rgba(25, 118, 210, 0.1);
}

/* Uploaded File Info */
.uploaded-file-info {
  position: relative;
  z-index: 2;
  animation: fadeInUp 0.3s ease;
}

.file-chip {
  font-weight: 500 !important;
  max-width: 280px;
  background: #ffffff!important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #000000;
}
.file-chip .v-chip--variant-tonal .v-chip__underlay{
  background: #ffffff!important;
}

.file-chip :deep(.v-chip__content) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Hidden Upload Component */
.hidden-upload {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  z-index: -1;
}

/* Responsive Design */
@media (max-width: 768px) {
  .upload-area {
    padding: 24px 16px;
    margin: 0 16px;
  }

  .upload-main-btn {
    height: 44px !important;
    padding: 0 20px !important;
  }

  .upload-text {
    font-size: 0.9rem;
  }

  .upload-info {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }

  .upload-hint {
    font-size: 0.8rem;
  }
}

/* Loading State */
.upload-main-btn:disabled {
  opacity: 0.6;
  transform: none !important;
  box-shadow: none !important;
}

.upload-main-btn:disabled:hover {
  transform: none !important;
  box-shadow: none !important;
}

/* Focus States */
.upload-main-btn:focus-visible {
  outline: 2px solid rgba(25, 118, 210, 0.5);
  outline-offset: 2px;
}

.upload-help-btn:focus-visible {
  outline: 2px solid rgba(25, 118, 210, 0.5);
  outline-offset: 2px;
}

/* Animation for file upload success */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Hover effects for better UX */
/* .upload-area .upload-main-btn:hover {
  box-shadow: 0 8px 25px rgba(25, 118, 210, 0.3) !important;
} */

/* .upload-area:hover .upload-hint {
  color: rgba(25, 118, 210, 0.8);
} */

.upload-info-icon {
  position: absolute;
  top: -8px;
  right: -8px;
}

/* Modern Inputs */
/* .modern-input {
  background: rgba(0, 0, 0, 0.01);
} */

.modern-input :deep(.v-field) {
  border-radius: 12px;
  transition: all 0.2s ease;
}

.modern-input :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.modern-input :deep(.v-field--focused) {
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);
}

.info-icon {
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.info-icon:hover {
  opacity: 1;
}

/* Columns Section */
.columns-section {
  margin-top: 32px;
}

.columns-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.columns-title {
  font-size: 1rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
  margin: 0;
}

.columns-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.column-card {
  border-radius: 16px !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
  background: rgba(0, 0, 0, 0.01);
}

.column-card:hover {
  border-color: rgba(25, 118, 210, 0.2);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
}

.column-content {
  padding: 20px;
}

.column-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.column-input {
  background: rgba(255, 255, 255, 0.8);
}

.column-options {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.modern-checkbox {
  flex: none;
}

.modern-checkbox :deep(.v-selection-control) {
  min-height: auto;
}

/* External Columns */
.external-columns-section {
  margin-top: 24px;
}

.add-column-btn {
  color: #C32E0E;
  font-weight: 500;
  text-transform: none !important;
  border-radius: 12px !important;
}
.add-column-btn:hover {
  background: #FDE4DF;
}
.external-columns-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
}

.external-column-card {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
  background: rgba(0, 0, 0, 0.01);
  width: 100%;
}

.external-column-card:hover {
  border-color: rgba(25, 118, 210, 0.2);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.external-column-content {
  padding: 16px;
}

.external-column-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.delete-column-btn {
  opacity: 0.6;
  transition: all 0.2s ease;
}

.delete-column-btn:hover {
  opacity: 1;
  background: rgba(244, 67, 54, 0.1);
}

.external-column-input {
  margin-bottom: 12px;
  background: rgba(255, 255, 255, 0.8);
}

.checkbox-label {
  display: flex;
  align-items: center;
  font-weight: 500;
}

/* Actions */
/* .modern-actions {
  padding: 16px 24px 24px 24px;
  background: rgba(0, 0, 0, 0.01);
}

.cancel-btn {
  padding: 0 15px;
  margin-right: 15px;
}

.cancel-btn:hover {
  background: rgba(0, 0, 0, 0.04);
} */

/* .save-btn {
  padding: 0 15px;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.25);
}

.save-btn:hover {
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.35);
  transform: translateY(-1px);
}

.save-btn:disabled {
  opacity: 0.5;
  transform: none;
  box-shadow: none;
} */

/* Responsive Design */
@media (max-width: 768px) {
  .modern-header {
    padding: 20px 16px 12px 16px;
  }

  .header-content {
    gap: 12px;
  }

  .header-icon {
    width: 40px;
    height: 40px;
  }

  .title-text {
    font-size: 1.25rem;
  }

  .modern-content {
    padding: 16px;
    max-height: 70vh;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .column-fields {
    grid-template-columns: 1fr;
  }

  .external-columns-grid {
    grid-template-columns: 1fr;
  }

  .radio-options {
    flex-direction: column;
    gap: 12px;
  }

  .column-options {
    flex-direction: column;
    gap: 8px;
  }

  .modern-actions {
    padding: 12px 16px 20px 16px;
    flex-direction: column;
    gap: 12px;
  }

  .action-btn {
    width: 100%;
  }
}

/* Smooth Scrollbar */
.modern-content::-webkit-scrollbar {
  width: 6px;
}

.modern-content::-webkit-scrollbar-track {
  background: transparent;
}

.modern-content::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

.modern-content::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.2);
}

/* personal info */
.personal-info-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 8px;
}

.personal-info-container {
  background-color: #EDEDED;
  border-radius: 8px;
  padding: 4px 12px;
  width: 100%;
  transition: all 0.2s ease;
}
.personal-info-container:hover {
  background-color: #FFF2F2;
}

.personal-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.personal-info-label {
  display: flex;
  align-items: center;
  cursor: help;
}

.personal-info-switch {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.personal-info-switch :deep(.v-switch__track) {
  opacity: 0.4;
}

.status-on {
  font-weight: 500;
  color: #646464;
}

.status-off {
  font-weight: 500;
  color: #757575;
}

.customadd{
  min-width: 100px!important;
  height: 40px!important;
  justify-content: center;
  align-items: center;
}

.modern-checkbox :deep(.v-checkbox .v-selection-control__wrapper) {
  color: #C32E0E;
}

.modern-checkbox :deep(.mdi-checkbox-blank-outline.mdi.v-icon.notranslate.v-theme--light.v-icon--size-default) {
  color: #C32E0E !important;
  opacity: 1 !important;
}
.success-banner {
  margin-top: 20px;
  width: 300px !important;
  height: 50px !important;
  border-radius: 16px !important;
  border: 2px solid #FFF !important;
  background: var(--success, linear-gradient(90deg, #2ABF56 0%, #135928 100%)) !important;
  color: white !important;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  display: flex !important;
  align-items: center !important;
  justify-content: center !important; /* centers text horizontally */
  animation: slideDown 0.4s ease;
  padding: 0px;
}

.success-banner-title {
  font-size: 22px !important;
  font-weight: 600 !important;
  margin: 0 !important;
  color: white !important;
  text-align: center !important;
  padding: 18px 10px 0px 10px !important;
}
</style>
